<app-generic-modal bodyClasses="p-0">
  <ng-template appModalHeader>
    <h2 class="m-0">
      {{ 'MANAGED_USERS.ADD_NEW_USER' | translate }}
    </h2>
  </ng-template>

  <ng-template appModalBody>
    <ul class="nav nav-pills d-flex gap-4 px-4 border-bottom">
      <li class="nav-item cursor-pointer flex-grow-1 flex-basis-0" (click)="activeTab = 'information'">
        <span class="nav-link full-bottom-border-width px-0" [class.active]="informationTabActive">
          {{ 'PROFILE.PROFILE_INFORMATION' | translate }}
        </span>
      </li>
      <li class="nav-item cursor-pointer flex-grow-1 flex-basis-0" (click)="onSetActiveTabToPermissions()">
        <span class="nav-link full-bottom-border-width px-0" [class.active]="!informationTabActive">
          {{ 'MANAGED_USERS.PERMISSIONS' | translate }}
        </span>
      </li>
    </ul>

    @if (activeTab === 'information') {
    <div class="p-4">
      <app-managed-user-profile [profileForm]="profileForm" />
    </div>
    } @else {
      <div class="p-4">
        <app-user-permissions [permissionsForm]="permissionsForm" [permissionOptions]="permissionOptions" />
      </div>
    }
  </ng-template>

  <ng-template appModalFooter>
    <button
      type="submit"
      class="btn btn-primary btn-lg w-50 d-flex align-items-center justify-content-center h-100 no-outline"
      (click)="informationTabActive ? onSetActiveTabToPermissions() : onAddUser()"
      data-testid="actionButton"
    >
      {{ (informationTabActive ? 'ACTIONS.NEXT' : 'MANAGED_USERS.ADD_NEW_USER') | translate }}
    </button>
  </ng-template>
</app-generic-modal>
